import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Parser from "html-react-parser";
import { Box, Button } from "@mui/material";
import { useAuth } from "hooks/useAuth";
import { setGlobalMessage } from 'hooks/useGlobalMessage';
import { useAgreeSignalTermsOfService, useGetTerms } from "applications/signal/hooks/gqlHooks";

export default function TermsOfServiceAgree() {
  const [agreeProcessing, setAgreeProcessing] = useState(false);
  const { signalUser } = useAuth();
  const navigate = useNavigate();
  const { agreeSignalTermsOfService } = useAgreeSignalTermsOfService();

  const { data, fetching, error } = useGetTerms();
  const content = data?.getTerms?.content || "";

  const handleAgreeClick = async () => {
    if (!signalUser?.signal_group_member_id) {
      return;
    }
    setAgreeProcessing(true);
    const {data, error} =await agreeSignalTermsOfService({ group_member_id: signalUser?.signal_group_member_id });
    if (error) {
      setGlobalMessage({
        message: "利用規約の同意に失敗しました。",
        severity: "error",
      });
      setAgreeProcessing(false);
      return;
    } else {
      navigate("/signal");
    }
  }

  const handleDisagreeClick = () => {
    navigate("/");
  }

  return (
    <Box>
      <h3>ご利用開始には以下利用規約に同意をお願いいたします。</h3>
      <Box
        className="ql-editor"
        sx={{
          margin: '20px 0',
          maxHeight: '600px',
          overflowY: 'scroll',
        }}
      >
        {Parser(String(content))}
      </Box>
      <Box
        sx={{
          width: '100%',
          padding: '20px 0',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <Button
          type="button"
          color="primary"
          variant="text"
          sx={{ width: "250px" }}
          onClick={handleDisagreeClick}
        >
          同意しない
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          sx={{ width: "250px" }}
          disabled={agreeProcessing}
          onClick={handleAgreeClick}
        >
          同意する
        </Button>
      </Box>
    </Box>
  )
}
